module.exports = __webpack_public_path__ + "img/Game_target_Z-04.c3436b17.png";